import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/register/index', '/user-business-voucher']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, asyncRouters, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (to.path.includes('/iframe/go')) {
            store.dispatch('app/full', true);
          } else {
            store.dispatch('app/full', false);
          }
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);
          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 8;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 1;
            break;
          }
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 7;
          break;
        case 1:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 2;
            break;
          }
          next();
          _context.next = 7;
          break;
        case 2:
          _context.prev = 2;
          _context.next = 3;
          return store.dispatch('user/getInfo');
        case 3:
          _context.next = 4;
          return store.dispatch('router/SetAsyncRouter');
        case 4:
          asyncRouters = store.getters['router/asyncRouters'];
          router.addRoutes(asyncRouters);
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 7;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](2);
          _context.next = 6;
          return store.dispatch('user/resetToken');
        case 6:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(encodeURIComponent(to.fullPath)));
          NProgress.done();
        case 7:
          _context.next = 9;
          break;
        case 8:
          /* has no token*/
          if (to.query.token) {
            store.commit('user/SET_TOKEN', {
              token: to.query.token,
              expire: new Date(Number(to.query.expire) + 3600000).toISOString()
            });
            store.commit('user/SET_EXPIRE', Number(to.query.expire) + 3600000);
          }
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(encodeURIComponent(to.fullPath)));
            NProgress.done();
          }
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 5]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});